import { useLingui } from '@lingui/react';
import { ActionIcon, Flex, Group, TextInput } from '@mantine/core';
import { SearchFilter } from '../Search/SearchFilter';
import classes from '../Search/SearchInput.module.css';
import { providers, sorts } from '../Search/data';
import { Icons } from '../Shares/Icons';
export const CasinoSearch: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Flex direction={{
    base: 'row',
    sm: 'column',
    lg: 'row'
  }} w="100%" gap={{
    base: 8,
    sm: 24,
    lg: 8
  }} wrap="nowrap" justify="center" align="center">
      <TextInput h={46} size="md" w="100%" radius={5} classNames={classes} style={{
      flexGrow: 1
    }} placeholder={i18n._('search...')} rightSection={<ActionIcon size="lg" variant="transparent" c="inherit">
            <Icons className="icon-pr-line-search" fontSize={24} color="inherit" />
          </ActionIcon>} />
      <Group gap={8} wrap="nowrap">
        <SearchFilter w={174} dropDownWidth={174} label={i18n._('Provider:')} filters={providers} breakPoint="sm">
          <Icons className="icon-pr-line-gaming" fontSize={24} />
        </SearchFilter>
        <SearchFilter w={174} dropDownWidth={174} label={i18n._('Sort by:')} filters={sorts} breakPoint="sm">
          <Icons className="icon-pr-line-filter" fontSize={24} />
        </SearchFilter>
      </Group>
    </Flex>;
};